/* eslint-disable react/prop-types */
import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

export default function SnackBarWiiba(props) {
  const { opensnack, tipoSnackBar, mensaje, handleClosesSnack } = props;

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  return (
    <>
      <Snackbar
        place="br"
        open={opensnack}
        autoHideDuration={6000}
        onClose={handleClosesSnack}
      >
        <Alert onClose={handleClosesSnack} severity={tipoSnackBar}>
          {mensaje}
        </Alert>
      </Snackbar>
    </>
  );
}
